import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function HeroSection() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return (
    <section className="relative overflow-hidden">
      {/* Background image - green cleaning theme */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20green%20eco%20cleaning%20service%20team%20working%20with%20modern%20equipment%20in%20bright%20clean%20space%2C%20lush%20green%20plants%20and%20botanical%20accents%2C%20eco-friendly%20cleaning%20products%20with%20green%20labels%2C%20natural%20light%20flooding%20through%20large%20windows%2C%20fresh%20clean%20aesthetic%20with%20white%20walls%20and%20green%20tones%2C%20high%20quality%20commercial%20cleaning%20company%20branding&width=480&height=620&seq=hero002&orientation=portrait"
          alt="Green Cleaning Service Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 px-6 pt-16 pb-12 text-center">
        {/* Logo badge */}
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/25 rounded-full px-4 py-1.5 mb-6">
          <div className="w-5 h-5 rounded-md bg-green-600 flex items-center justify-center flex-shrink-0">
            <i className="ri-leaf-line text-white text-xs"></i>
          </div>
          <span className="text-white text-xs font-semibold tracking-wide">finfins</span>
        </div>

        <h1 className="text-white font-bold text-3xl leading-tight mb-3">
          The Greener Way to<br />
          <span className="text-green-400">Manage Cleaning Services</span>
        </h1>
        <p className="text-white/80 text-sm leading-relaxed mb-8">
          {isAuthenticated
            ? 'You are already signed in. The 1-month free trial can only be claimed once, when you create a new team.'
            : 'Claim a 1-month free trial when you create a new team. Full access, once per account.'}
        </p>

        <div className="flex flex-col gap-3">
          {isAuthenticated ? (
            <button
              type="button"
              onClick={() => navigate('/orders')}
              className="w-full bg-green-600 text-white font-semibold text-sm py-3.5 rounded-xl cursor-pointer whitespace-nowrap"
            >
              Go to workspace
            </button>
          ) : (
            <button
              type="button"
              onClick={() => navigate('/register')}
              className="w-full bg-green-600 text-white font-semibold text-sm py-3.5 rounded-xl cursor-pointer whitespace-nowrap"
            >
              Start 1-month free trial
            </button>
          )}
          <button
            type="button"
            onClick={() => {
              document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm py-3.5 rounded-xl cursor-pointer whitespace-nowrap"
          >
            View Pricing
          </button>
        </div>

        {/* Trust badges */}
        <div className="flex items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <div className="text-white font-bold text-xl">2,400+</div>
            <div className="text-white/60 text-[10px]">Companies</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-white font-bold text-xl">98%</div>
            <div className="text-white/60 text-[10px]">Satisfaction</div>
          </div>
          <div className="w-px h-8 bg-white/20"></div>
          <div className="text-center">
            <div className="text-white font-bold text-xl">4.9★</div>
            <div className="text-white/60 text-[10px]">App Rating</div>
          </div>
        </div>
      </div>
    </section>
  );
}
